import { TStringField, TLinkField, TDropdownSelect } from '../types/sitecore.types';
import { TFooterLink, TFooterLinkFields } from '../types/footerLink.types';

export class FooterLinkModel {
  private readonly fields?: TFooterLinkFields;

  constructor(props: TFooterLink) {
    this.fields = props.fields;
  }

  get link(): TLinkField | undefined {
    return this.fields?.link;
  }

  get list(): TFooterLink[] {
    return this.fields?.list && Array.isArray(this.fields?.list) ? this.fields?.list : [];
  }

  get title(): TStringField | undefined {
    return this.fields?.title;
  }

  get groupTitle(): string | undefined {
    return this.fields?.link?.value?.text;
  }

  get type(): TDropdownSelect | undefined {
    return this.fields?.type;
  }
}
